import AxiosService from "plugins/TS-lib-utils-public/services/AxiosService"; 

class patientService extends AxiosService {
    constructor() {
        super("aspect-patient-user");
    }

    updateExtRef = async (data) => {
        return await this.put(`/profile/${data.auth_user_id}/ext_ref`, data, {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
            },
        });
    }

}

export default new patientService();
